import { EnvironmentUrls, CurrentUser } from 'Roblox';

const { premiumFeaturesApi, universalAppConfigurationApi } = EnvironmentUrls;
const { userId } = CurrentUser;

const getSubscriptionPlansConfig = () => {
  return {
    withCredentials: true,
    url: `${premiumFeaturesApi}/v1/products`
  };
};

const getUserStatusConfig = () => {
  return {
    withCredentials: true,
    url: `${premiumFeaturesApi}/v1/users/${userId}/subscriptions`
  };
};

const getProductPolicyConfig = () => {
  return {
    withCredentials: true,
    url: `${universalAppConfigurationApi}/v1/behaviors/robux-product-policy/content`
  };
};

const getMobilePaymentUrl = params => {
  return `/mobile-app-upgrades/buy?${params}`;
};

const getDesktopPaymentUrl = params => {
  return `/upgrades/paymentmethods?${params}`;
};

const urls = {
  subscribePageUrl: '/premium/membership?ctx=robux',
  termsUrl: '/info/terms',
  privacyUrl: '/info/privacy',
  billingSettingUrl: '/my/account#!/billing',
  catalogUrl: '/catalog/?Category=14&Subcategory=50',
  premiumGameUrl: '/games/?SortFilter=23&TargetId=65',
  incrementPremiumUpsellShownForAssetUrl: '/v1/asset/{targetId}/premium-upsell-shown/increment',
  incrementPremiumUpsellShownForBundleUrl: '/v1/bundle/{targetId}/premium-upsell-shown/increment'
};

export default {
  getSubscriptionPlansConfig,
  getUserStatusConfig,
  getProductPolicyConfig,
  getMobilePaymentUrl,
  getDesktopPaymentUrl,
  urls
};
